import * as React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
import { cleanProps } from '../../utilities/props';
import Menu from '../../components/PageLayout/Menu';
export default function () {
    return React.createElement('section', _.assign({}, { 'ref': this.props.setScrollContainer }, _.assign({}, cleanProps(this.props))), React.createElement(Menu, {
        'componentClassName': 'app-menu',
        'component': this.props.pageMenu
    }), React.createElement('div', { 'className': this.props.contentClassName }, '\r\n        ', this.props.children, '\r\n    '));
}